export const host =
  process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000';
export const mapsKey =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyDkKRY5r09a06PD_lMbLttP64CerxQEiR8'
    : 'AIzaSyDkKRY5r09a06PD_lMbLttP64CerxQEiR8';
